import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'
import { getValues, prepareValues } from '@/lib/values'

export const person_edit = {

  namespaced: true,

  state: {
    values: {},
    entities: [],
  },

  getters: {
    values: state => state.values,
    entities: state => state.entities,
  },

  mutations: {
    setValues(state, values) { state.values = values },
    setEntities(state, entities) { state.entities = entities },
  },

  actions: {

    getEntities: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Person'],
      form_display: true,
    }}),

    async getForm({ rootState, commit, dispatch }) {
      commit('clearResponse', {}, { root: true });
      commit('setEntities', []);
      const entities = await dispatch('getEntities');
      commit('setProgress', false, { root: true });
      commit('setValues', getValues('person', entities.data['App\\Models\\Person'], 'content'));
      let countries = entities.data['App\\Models\\Person'].findIndex(entity => entity.column === 'country_code');
      entities.data['App\\Models\\Person'][countries].options = entities.data['App\\Models\\Person'][countries].options.sort((a, b) => rootState._[a.name].localeCompare(rootState._[b.name]));
      commit('setEntities', entities.data['App\\Models\\Person']);
    },

    async validatePerson({ state, rootState, commit, dispatch }) {
      if (!rootState.progress) {
        if (router.currentRoute.params.id) state.values.id = router.currentRoute.params.id;
        try {
          await Vue.axios.post(API_URL + '/validate?model=App\\Models\\Person', state.values, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });
        } catch (error) {
          commit('setProgress', false, { root: true });
          commit('setResponse', { status: true, type: 'error', message: 'form_error', errors: error.response.data.errors }, { root: true });
          return;
        }
        dispatch('existingPerson');
      }
    },

    async existingPerson({ state, commit, dispatch }) {
      const persons = await Vue.axios.post(API_URL + '/persons/exist', state.values, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      if (persons && persons.data && persons.data.length) {
        commit('setProgress', false, { root: true });
        commit('setResponse', { status: true, type: 'warning', message: persons.data, errors: [] }, { root: true });
        return;
      }
      const values = prepareValues(state.values, state.entities, 'content_');
      dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Person', values);
    },

    createPersonAnyway({ state, dispatch }) {
      const values = prepareValues(state.values, state.entities, 'content_');
      dispatch(((!router.currentRoute.params.id) ? 'create' : 'update') + 'Person', values);
    },

    async createPerson({ commit }, values) {
      const response = await Vue.axios.post(API_URL + '/persons', values);
      commit('setProgress', false, { root: true });
      router.push('/person/' + response.data.id + '/edit');
      commit('setResponse', { status: true, type: 'success', message: 'person_successfully_created' }, { root: true });
    },

    async updatePerson({ state, commit }, values) {
      const person = await Vue.axios.put(API_URL + '/persons/' + router.currentRoute.params.id, values);
      commit('person/setPerson', person.data, { root: true });
      commit('setValues', getValues('person', state.entities, 'content'));
      commit('setProgress', false, { root: true });
      commit('setResponse', { status: true, type: 'success', message: 'person_successfully_updated' }, { root: true });
    },

  }
}
